export default __webpack_public_path__ + "assets/3ce2b8115f7b2537cb8f09e4f5941c80.png";